import { useTranslation } from "react-i18next";
import type { RouteMeta } from "@/app/routes";
import { PAGE_PRESENTATION } from "./navigation";

export interface PageCopy {
  eyebrow: string;
  title: string;
  description: string;
}

/** Testi di topbar e PageHeader per la rotta corrente (stessa logica di `pagePresentation` in App.jsx). */
export function usePageCopy(route: RouteMeta): PageCopy {
  const { t } = useTranslation();
  const presentation: unknown = t(`shell.pages.${PAGE_PRESENTATION[route.name] ?? "fallback"}`, {
    returnObjects: true,
  });
  if (presentation && typeof presentation === "object") return presentation as PageCopy;
  return { eyebrow: route.group, title: route.name, description: t("shell.pages.fallback.description") };
}
